var _circle, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapRadius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30,
    fill: "#38CB89",
    fillOpacity: 0.1,
    stroke: "#38CB89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7138_23760)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0072,
    cy: 41.5896,
    rx: 3.33529,
    ry: 1.19117,
    fill: "black",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0059 18C35.5319 18 40.0117 22.4798 40.0117 28.0059C40.0117 32.2429 37.3781 35.8648 33.6586 37.324L30.5758 41.5379C30.5115 41.6261 30.4262 41.6981 30.327 41.7478C30.2278 41.7975 30.1176 41.8235 30.0059 41.8235C29.8941 41.8235 29.7839 41.7975 29.6848 41.7478C29.5856 41.6981 29.5002 41.6261 29.436 41.5379L26.3531 37.324C22.6336 35.8648 20 32.2429 20 28.0059C20 22.4798 24.4798 18 30.0059 18Z",
    fill: "#F75751"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2952 28.007C34.2952 25.6387 32.3753 23.7188 30.007 23.7188C27.6387 23.7188 25.7188 25.6387 25.7188 28.007C25.7188 30.3753 27.6387 32.2952 30.007 32.2952C32.3753 32.2952 34.2952 30.3753 34.2952 28.007Z",
    fill: "#BE2E28"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7138_23760",
    x: 25.7189,
    y: 39.4455,
    width: 8.57775,
    height: 4.28869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.476469,
    result: "effect1_foregroundBlur_7138_23760"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRadius);
export default __webpack_public_path__ + "static/media/map-radius.407fdbe44b813e19e26b5f3eabacd2af.svg";
export { ForwardRef as ReactComponent };